/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const EnumChatMessageRepliedStatus = {
    Error: 'error',
    Replied: 'replied',
    None: 'none'
};
export function EnumChatMessageRepliedStatusFromJSON(json) {
    return EnumChatMessageRepliedStatusFromJSONTyped(json, false);
}
export function EnumChatMessageRepliedStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EnumChatMessageRepliedStatusToJSON(value) {
    return value;
}
